import { useState, useEffect } from "react";

export default function WeekViz( { pWidth = 2, pColor = "var(--grey)", pFontSize = "var(--font-size-teeny)", scale = 1.0, isMobile = false } ){
    const [date, setDate] = useState(new Date());
    
    useEffect( () => {
        const timer = setInterval(() => {
            setDate(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    // ISO week number (weeks start on Monday, no local timezone drift)
    const getWeekNumber = (date) => {
        const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        const dayNumber = utcDate.getUTCDay() || 7; // Make Sunday = 7
        utcDate.setUTCDate(utcDate.getUTCDate() + 4 - dayNumber); // Shift to nearest Thursday
        const yearStart = new Date(Date.UTC(utcDate.getUTCFullYear(), 0, 1));
        return Math.ceil(((utcDate - yearStart) / 86400000 + 1) / 7);
    };

    const dayOfWeek = date.toLocaleString('default', { weekday: 'short' });
    // 0=Sunday, 1=Monday, ..., 6=Saturday
    const jsDay = date.getDay();
    const month = date.toLocaleString('default', { month: 'short' });
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    const week = Number(getWeekNumber(date));

    let hours = date.getHours();
    let minutes = String(date.getMinutes()).padStart(2, '0');
    const period = hours >= 12 ? 'PM' : 'AM';

    if (hours > 12) {
        hours -= 12;
    } else if (hours === 0) {
        hours = 12;
    }
    
    // const formattedDate = `WEEK ${week} · ${dayOfWeek} ${month} ${day} ${year} · ${hours}:${minutes} ${period}`;
    const formattedDate = `${dayOfWeek} ${month} ${day} ${year} · ${hours}:${minutes} ${period}`;
    // const formattedDate = `${dayOfWeek} ${month} ${day} ${year}`;
    const formattedTime = `${hours}:${minutes} ${period}`;

    return(
        <div style={{
        transform: `scale(${scale})`,
        transformOrigin: "center right",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
        height: "48px",
        marginLeft: "12px",
        ...(isMobile ? { flex : 1, width : "100%", flex : 1 } : {})
        }}>
            <h1 style = { { fontWeight : "500", fontSize : "40px", fontFamily : "var(--font-Source)", color : "var(--black72)", lineHeight: "100%" } }>{ week }</h1>
            
            <div style = { { display : "flex", flexDirection : "column", gap : "6px", width : "100%" } }>
                <p style = { { color : `${ pColor }`, fontSize : `${ pFontSize }`, lineHeight : "100%", fontWeight : "600" } }>{ formattedDate }</p>
                {/* <p style = { { color : `${ pColor }`, fontSize : `${ pFontSize }`, lineHeight : "200%" } }>{ formattedTime }</p> */}
            
                <div style = { { flex : 1, width : "100%" } }>
                    {/* 7 Days */}
                    <div style = { { display : "flex", flexDirection : "row", gap : "1px", paddingBottom : "2px" } }>
                        { Array.from( { length : 7 }, ( _, i ) => (
                            <span key = { i } style = {{
                                flex : 1,
                                height : `${pWidth + 2}px`,
                                backgroundColor : i + 1 <= jsDay ? "var(--grey)" : "var(--black8)"
                            }}/>
                        )) }
                    </div>
                    
                    {/* 52 Weeks */}
                    <div style = { { display : "flex", flexDirection : "row", gap : "1px" } }>
                        { Array.from( { length : 52 }, ( _, i ) => (
                            <span key = { i } style = { {
                                flex : 1,
                                // width : `${pWidth}px`,
                                height : `${pWidth + 1}px`, backgroundColor : i < week ? "var(--grey)" : "var(--black8)" } }/>
                        ) ) }
                    </div>
                </div>
            </div>
        </div>
    )
}